'use client';
import React, { useState } from 'react';
import SignUpLoginContent from './sign-up-login-screen/components/SignUpLoginContent';

export default function HomePage() {
  const [lang, setLang] = useState<'vi' | 'en'>('vi');
  const [darkMode, setDarkMode] = useState(false);

  return (
    <div className={darkMode ? 'dark' : ''}>
      <SignUpLoginContent
        lang={lang}
        onLangChange={setLang}
        darkMode={darkMode}
        onDarkModeChange={setDarkMode}
      />
    </div>
  );
}